import React from 'react';
import classnames from 'classnames';

import { TagResource } from 'util/api/swaggerApi/data-contracts';

import Tag from 'components/atoms/Tag';

import styles from './index.module.css';

interface TagListProperty {
	className?: string;
	tagSize?: 'medium' | 'small';
	hasLink?: boolean;
	tagsData: TagResource[];
}

const TagList: React.FC<TagListProperty> = ({ className, tagSize, hasLink = false, tagsData }) => (
	<div className={classnames(styles.tagList, className)}>
		{tagsData &&
			tagsData.map(tag => (
				<Tag key={tag.id} size={tagSize} tagId={tag.id} tagName={tag.name} hasLink={hasLink} />
			))}
	</div>
);

export default TagList;
